import { axios } from '@Root/API'

export const remove = (studyProgrammeId, studyLocationId ) => {
	return axios.delete(`course-session/${studyProgrammeId}/student-financial-support/${studyLocationId}`)
}
